module.exports = __webpack_public_path__ + "img/omil_web.42114d50.png";